<template>
  <div class="background">
    <div class="main-body">
      <div class="left-panel">
        <h1>{{ currentUser.name }}</h1>
        <span>{{ currentUser.mobile }}</span>
        <span class="logout-btn" @click="logoutFunc">退出登录</span>
      </div>
      <div class="right-panel">
        <!-- <div class="invite-block">
                    <h1>公司邀请</h1>
                    <Table v-if="invitationList.length !== 0" :columns="columns" :data="invitationList" size="small">
                        <template slot-scope="{ row, index }" slot="action">
                            <Button type="primary" size="small" style="" @click="joinCompany(row)">加入公司</Button>
                        </template>
                    </Table>
                    <span v-else>暂无公司邀请，请联系公司负责人，或刷新界面</span>
        </div>-->

        <div class="register-block">
          <h1>注册公司</h1>
          <Form
            ref="formItem"
            :model="formItem"
            :label-width="80"
            style="width: 300px"
            :rules="ruleValidate"
          >
            <FormItem label="公司名" prop="name">
              <Input v-model="formItem.name" placeholder="输入公司名" :autofocus="true" />
            </FormItem>
            <FormItem label="公司代码" prop="code">
              <Input v-model="formItem.code" placeholder="输入公司代码" />
            </FormItem>
            <FormItem
              v-for="(item, index) in formItem.factoryList"
              :key="index"
              :label="`工厂${index + 1}`"
              :prop="'factoryList.' + index + '.name'"
              :rules="{required: true, message: `工厂${index + 1}不能为空`, trigger: 'blur'}"
            >
              <Row>
                <Col span="18">
                  <Input type="text" v-model="item.name" placeholder="工厂名"></Input>
                </Col>
                <Col span="4" offset="1">
                  <Button @click="handleRemove(index)">删除</Button>
                </Col>
              </Row>
            </FormItem>
            <FormItem>
              <Row>
                <Col span="12">
                  <Button type="dashed" long @click="handleAdd" icon="md-add">增加新厂</Button>
                </Col>
              </Row>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "signup_company",
  components: {},
  data() {
    return {
      index: 1,
      invitationList: [],
      registerCompanySwitch: false,
      formItem: {
        name: "",
        code: "",
        factoryList: [
          {
            name: "",
          },
        ],
      },
      ruleValidate: {
        name: [{ required: true, message: "请填写名字", trigger: "blur" }],
        code: [
          { required: true, message: "请填写公司代码", trigger: "blur" },
          {
            type: "string",
            min: 4,
            max: 6,
            message: "公司代码必须为4-6位字符或数字",
            trigger: "blur",
          },
        ],
      },
      columns: [
        {
          title: "公司",
          key: "company.name",
          width: 150,
          render: (h, params) =>
            h("span", _.get(params.row, "company.name", "不存在")),
        },
        {
          title: "邀请人",
          key: "invitedBy.name",
          render: (h, params) =>
            h("span", _.get(params.row, "invitedBy.name", "不存在")),
        },
        {
          title: "手机",
          key: "invitedBy.moible",
          width: 120,
          render: (h, params) =>
            h("span", _.get(params.row, "invitedBy.mobile", "不存在")),
        },
        {
          title: "操作",
          key: "action",
          slot: "action",
        },
      ],
    };
  },
  computed: {
    ...mapState("auth", ["currentUser"]),
  },
  methods: {
    ...mapActions("company", [
      "createCompanyAction",
      "getMyInvitationAction",
      "acceptInvitationAction",
    ]),
    ...mapActions("auth", ["logout", "getUserInfoAction"]),
    ...mapActions("department", ["getDepartmentsAction"]),
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            const company = await this.createCompany(this.formItem);
            this.$Message.success("保存成功!");
            this.getUserInfo();
            this.getDepartments({ saveTo: "root", api: {} });
            this.$router.push("/h/customer");
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handleAdd() {
      this.index++;
      this.formItem.factoryList.push({
        name: "",
      });
    },
    handleRemove(index) {
      // this.formItem.factoryList[index].status = 0;
      this.formItem.factoryList.splice(index, 1);
    },
    chooseBlock(v) {
      this.selectedBlock = v;
    },
    joinCompany(row) {
      this.acceptInvitation({ invitation: row._id });
    },
    logoutFunc() {
      this.logout();
      this.$router.push("/");
    },
  },
  created() {
    // this.getMyInvitation().then((doc) => {
    //     if (_.isArray(doc)) this.invitationList = doc
    // }).catch((err) => {
    // });
  },
};
</script>

<style scoped lang="stylus">
.background
  width 100%
  height 100vh
  background-color #425384
  overflow hidden
  display flex
  justify-content center
  align-items center

.main-body
  width 700px
  height 80vh
  background-color white
  border-radius 6px
  padding 12px

.left-panel
  width 176px
  height 100%
  float left
  position relative
  padding 12px

.right-panel
  width 500px
  height 100%
  float left
  overflow-y auto

.logout-btn
  color lightgray
  cursor pointer
  bottom 12px
  left 12px
  position absolute

.invite-block
  background-color #f0f3ff
  border-radius 6px
  padding 12px
  margin-bottom 24px

.register-block
  background-color #f0f3ff
  border-radius 6px
  padding 12px
  margin-bottom 24px
</style>
